export const popupConstants = {
    POPUP_UPDATE: 'POPUP_UPDATE',
    SET_POPUP_VISIBLE: 'SET_POPUP_VISIBLE',
    TOGGLE_POPUP: 'TOGGLE_POPUP',
};

export const POPUP_VIEW_TYPE = {
    WEB_APP: 'WEB_APP',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    KYC_NOTIFICATION: 'KYC_NOTIFICATION',
    TELEGRAM_GUIDELINE_POPUP: 'TELEGRAM_GUIDELINE_POPUP',
    DEPOSIT_AMOUNT: 'DEPOSIT_AMOUNT',
    SUMSUB: 'SUMSUB',
};
